export const STORAGE_VALUE_PREFIX = '__wms_'
export const STORAGE_TYPE = 'local' // 'local/session'
export const STORAGE_USE_EXPIRES = false
export const PREFIX_CLASS = 'wms'
